module.exports = __webpack_public_path__ + "build/assets/STIXTwoText-Regular-8803d36d0f419ca4f5ed415deb3b0027.woff2";